import { documentTypeTaxonomyById } from '@lio/rule-engine';
import { DocumentType } from '@models/document';

type WithDocumentType = { documentType: { id: string } };
type WithDocumentTypeAndName = { documentType: { id: string; name: string } };
type WithReplacementInfo = { documentGeneration: unknown; replacedByDocuments: unknown[] };

export const isDocumentVisible = (doc: WithDocumentType, isInternalUser: boolean): boolean => {
  const taxonomy = documentTypeTaxonomyById[doc.documentType.id];
  if (!taxonomy) return isInternalUser;
  return isInternalUser ? taxonomy.internalVisible : taxonomy.brokerVisible;
};

export const filterDocumentsByVisibility = <T extends WithDocumentType>(docs: T[], isInternalUser: boolean): T[] =>
  docs.filter((doc) => isDocumentVisible(doc, isInternalUser));

export const filterLatestDocuments = <T extends WithReplacementInfo>(docs: T[]): T[] =>
  docs.filter((doc) => !doc.documentGeneration || doc.replacedByDocuments.length === 0);

export const relabelForLio = <T extends WithDocumentTypeAndName>(docs: T[], isWritingCompanyLio: boolean): T[] => {
  if (!isWritingCompanyLio) return docs;
  return docs.map((doc) =>
    doc.documentType.id === DocumentType.ConfirmationOfCoverage.id
      ? ({ ...doc, documentType: { ...doc.documentType, name: DocumentType.ConfirmationOfCoverage.name } } as T)
      : doc,
  );
};
